<template>
  <div>
    <!--modal for QR scanner -->
    <div v-show="scanning" class="QRScanner-lock" @click="closeScanner" >......</div>
    <div v-show="scanning" class="QRScanner-container">
      <label class="modal-close" for="modal-toggle" @click="closeScanner">&#x2715;</label>
      <el-steps class="steps" :active="active" align-center finish-status="success">
        <el-step title="Instructions"></el-step>
        <el-step title="Scan QR-Code"></el-step>
      </el-steps>
      <div class="instructions-wrapper" v-if="active == 1">
        <div >
          <div>Just two quick steps!</div>
        </div>
        <div class="instructions">
          <img src="../assets/img/QR.png">
          <ul>
            <li>Locate the <b>QR-Code</b> on your ninja</li>
            <li>Click <b>Scan</b> button to scan ninja</li>
          </ul>
        </div>
      </div>
      <el-button v-if="active == 1" type="success" @click="next">Scan</el-button>
      <div class="camera-wrapper" v-show="active == 2">
        <el-select class="select-camera" v-model="cameraIndex" placeholder="Choose a camera">
        <el-option 
          v-for="(camera, index) in cameras" 
          :key="camera.id" 
          :label="formatName(camera.name, index)" 
          :value="index">
        </el-option>
      </el-select>
      <div id="scanner-wrapper">
        <video id="scanner"></video>
      </div>
      <el-button type="text" @click="noQR">I don't have a camera</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Instascan from '../../static/js/instascan/index';
import nem from '../../static/js/index';


export default {
  props: ['scanning'],
  data() {
    return {
      scanner: null,
      cameras: [],
      cameraIndex: 0,
      active: 1,
    };
  },
  methods: {
    formatName(name, index) {
      return name || `Camera ${index}`;
    },
    closeScanner() {
      this.$emit('update:scanning', false);
      this.active = 1;
      this.scanner.stop();
    },
    next() {
      this.active += 1;
      if (this.cameras.length > 0) {
        this.scanner.start(this.cameras[this.cameraIndex]);
      } else {
        // if there is no camera straight to form
        this.noQR();
      }
    },
    noQR() {
      const that = this;
      this.closeScanner();
      this.$prompt('Please Enter the ID', 'Claim or verify your document', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (nem.model.address.isValid(result.value)) {
          that.$router.push({
            name: 'Product',
            params: { address: result.value },
          });
        } else {
          this.$notify({
            type: 'error',
            message: 'Invalid Product ID',
          });
        }
      }).catch(() => {
        this.$notify({
          type: 'info',
          message: 'Operation canceled',
        });
      });
    },
  },
  mounted() {
    const that = this;

    if (this.$MOBILE) {
      // no mirroring because the camera is not facing
      this.scanner = new Instascan.Scanner({
        video: document.getElementById('scanner'),
        mirror: false,
      });
    } else {
      // camera facing mirror default to true
      this.scanner = new Instascan.Scanner({
        video: document.getElementById('scanner'),
      });
    }

    this.scanner.addListener('scan', (result) => {
      that.closeScanner();
      if (nem.model.address.isValid(result)) {
        that.$router.push({
          name: 'Product',
          params: { address: result },
        });
      } else {
        that.$notify({
          message: 'QR-Code is not valid',
          type: 'error',
        });
      }
    });

    /* Instascan.Camera.getCameras().then((cameras) => {
      this.cameras = cameras;
      if (cameras.length > 0) {
        this.camera = cameras[0];
      } else {
        this.cameras = [];
        this.camera = null;
        this.$notify({
          message: 'No camera found!',
          type: 'error',
          showClose: true,
        });
      }
    }).catch((e) => {
      this.$message({
        message: 'Camera detection error',
        type: 'error',
        showClose: true,
      });
    }); */
  },
  watch: {
    cameraIndex() {
      if (this.scanning === true) {
        this.scanner.start(this.cameras[this.cameraIndex]);
      }
    },
    scanning: function (newVal, oldVal) {
      if (newVal === true) {
        Instascan.Camera.getCameras().then((cameras) => {
          this.cameras = cameras;
          if (cameras.length > 0) {
            this.camera = cameras[0];
            // this.$message({
            //   message: `found ${cameras.length} cameras`,
            //   type: 'success',
            //   showClose: true,
            // });
          } else {
            this.cameras = [];
            this.camera = null;
            this.$notify({
              message: 'No camera found!',
              type: 'error',
              showClose: true,
            });
          }
        }).catch((e) => {
          this.$message({
            message: 'Camera detection error',
            type: 'error',
            showClose: true,
          });
        });
      }
    },
  },
};
</script>

<style>
.camera-wrapper {
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

#scanner-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#scanner {
  width: 100%;
  height: 100%;
}

.QRScanner-container {
  width: 90%;
  height: 90%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  box-sizing: border-box;
  z-index: 1999;
  margin: auto;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(133, 133, 133);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

.QRScanner-lock{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  z-index: 1995;
  margin: auto;
  display: block;
  background-color: #000;
  opacity: .3;
}

.steps {
  width: 100%;
  margin: 20px;
}

.select-camera{
  margin-bottom: 8px;
}

.modal-close {
  color: #aaa;
  position: absolute;
  right: 5px;
  top: 5px;
  padding-top: 3px;
  background: #fff;
  font-size: 16px;
  width: 25px;
  height: 25px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
}
.modal-close:hover {
  color: #333;
}  

@media only screen and (min-width: 768px)  {
  .QRScanner-container {
    max-height: 639px;
    max-width: 560px;
  }
  .instructions-wrapper {
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}

.instructions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.instructions ul{
  padding: 0;
}

</style>



// WEBPACK FOOTER //
// Scan.vue?7302b3d5